import { createApiRef, discoveryApiRef, oauthRequestApiRef, configApiRef } from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { ApiBlueprint } from '@backstage/frontend-plugin-api'; 
import { OpenIdConnectApi, ProfileInfoApi, BackstageIdentityApi, SessionApi } from '@backstage/core-plugin-api';

export const keycloakAuthApiRef = createApiRef<
  OpenIdConnectApi &
  ProfileInfoApi &
  BackstageIdentityApi &
  SessionApi
>({
  id: 'auth.oidc.keycloak',
});

// We use the new defineParams callback and remove createApiFactory
export const keycloakAuthApiExtension = ApiBlueprint.make({
  name: 'keycloak', 
  params: defineParams => defineParams({
    api: keycloakAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) => {
      
      // 1) Read the selected environment
      const environment = configApi.getOptionalString('auth.environment') ?? 'production';

      // 2) Read env-scoped default scopes
      const defaultScopes = configApi.getOptionalStringArray(
        `auth.providers.keycloak.${environment}.defaultScopes`,
      ) ?? ['openid', 'profile', 'email', 'offline_access'];

      // 3) Create the auth API
      return OAuth2.create({
        discoveryApi,
        oauthRequestApi,
        provider: {
          id: 'keycloak', 
          title: 'Keycloak',
          icon: () => null,
        },
        environment: environment,   
        defaultScopes: defaultScopes,
        popupOptions: {
          size: {
            width: 1024,
            height: 768,
          },
        },
      });
    },
  }),
});